"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InboxOverlayModule = /** @class */ (function () {
    function InboxOverlayModule() {
    }
    return InboxOverlayModule;
}());
exports.InboxOverlayModule = InboxOverlayModule;
